import React from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { WhetherIconsWithAnimations } from '../../../Constant';
import { weatherIconData } from '../../../Data/Icons/Data';
import HeaderCard from '../../Common/HeaderCard';

const WeatherIconsContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Whether Icon' parent='Icons' title='Whether Icon' />
      <Row>
        <Col sm='12'>
          <Card>
            <HeaderCard title={WhetherIconsWithAnimations} />
            <CardBody>
              <Row className='icon-lists whether-icon'>
                {weatherIconData.map((icon, i) => (
                  <Col lg='2 col-3' key={i}>
                    {icon.icon}
                  </Col>
                ))}
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default WeatherIconsContainer;
